<template>
  <div class="auth-login__card">
    <header v-if="title || subtitle || $slots.subtitle" class="auth-login__card-header">
      <h2
        v-if="title"
        class="auth-login__card-title"
        :class="{ 'auth-login__card-title--center': headerCentered }"
        tabindex="-1"
        data-step-focus
      >
        {{ title }}
      </h2>
      <p
        v-if="subtitle || $slots.subtitle"
        class="auth-login__card-subtitle"
        :class="{ 'auth-login__card-subtitle--center': headerCentered }"
      >
        <slot name="subtitle">{{ subtitle }}</slot>
      </p>
    </header>

    <slot />

    <footer v-if="$slots.footer || $slots['card-links']" class="auth-login__card-footer">
      <div v-if="$slots['card-links']" class="auth-login__card-links">
        <slot name="card-links" />
      </div>
      <slot name="footer" />
    </footer>
  </div>
</template>

<script setup>
defineProps({
  title:          { type: String, default: '' },
  subtitle:       { type: String, default: '' },
  headerCentered: { type: Boolean, default: false },
})
</script>
